import { css, Global } from "@emotion/react";
import React from "react";

const GlobalStyles = ({ width, height }) => {
  const globalStyles = css`
    .css-lw5ihw-JoySheet-root {
      width: ${width} !important;
      height: ${height} !important;
    }
    .css-og5q4v-JoyLink-root {
      padding-top: 0px !important;
      padding-bottom: 0px !important;
      line-height: var(--joy-lineHeight-md, 0.1) !important;
    }
  `;

  return <Global styles={globalStyles} />;
};

const SC = {
  GlobalStyles,
};

export default SC;
